"use client";

import { Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DEMO_SECTIONS, EXAM_RULES_LIST } from "@/app/coba/_components/demo-data";

/* Shared overview content used by both desktop modal and mobile bottom sheet */
export function OverviewContent({
  totalDuration,
  totalQuestions,
  onStart,
}: {
  totalDuration: number;
  totalQuestions: number;
  onStart: () => void;
}) {
  return (
    <>
      <div className="flex items-center gap-3">
        <div className="from-primary to-primary shadow-soft flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br">
          <Play size={18} fill="white" className="text-primary-foreground" />
        </div>
        <div>
          <h2 className="text-foreground text-lg font-black">Simulasi CPNS - SKD</h2>
          <p className="text-foreground/40 text-xs font-bold">Demo gratis tanpa login</p>
        </div>
      </div>
      <div className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-2">
        {[
          { label: "Seksi", value: String(DEMO_SECTIONS.length) },
          { label: "Soal", value: String(totalQuestions) },
          { label: "Menit", value: String(totalDuration) },
        ].map((s) => (
          <div key={s.label} className="text-center">
            <p className="text-foreground text-lg font-black">{s.value}</p>
            <p className="text-foreground/60 text-3xs font-bold">{s.label}</p>
          </div>
        ))}
      </div>
      <div className="border-border/60 my-4 border-t-2 border-dashed" />
      <h3 className="text-foreground text-sm font-black">Aturan Ujian</h3>
      <div className="mt-2 flex flex-col gap-0">
        {EXAM_RULES_LIST.map((rule, i) => (
          <div key={i} className="flex gap-3 py-2">
            <span className="bg-primary text-primary-foreground text-3xs shadow-soft-sm flex h-6 w-6 shrink-0 items-center justify-center rounded-lg font-black [--soft-shadow-color:var(--primary)]">
              {i + 1}
            </span>
            <span className="text-foreground/60 text-xs leading-relaxed font-medium">
              {rule}
            </span>
          </div>
        ))}
      </div>
      <div className="border-border/60 my-4 border-t-2 border-dashed" />
      <h3 className="text-foreground text-sm font-black">Komposisi Ujian</h3>
      <div className="mt-3 flex flex-col gap-2">
        {DEMO_SECTIONS.map((sec, i) => (
          <div
            key={sec.id}
            className="border-border/60 shadow-soft-md rounded-xl border-2 p-3.5"
          >
            <div className="flex items-center gap-2.5">
              <span className="bg-primary text-primary-foreground text-3xs shadow-soft-md flex h-7 w-7 items-center justify-center rounded-lg font-black [--soft-shadow-color:var(--primary)]">
                {i + 1}
              </span>
              <div>
                <p className="text-foreground text-sm font-bold">{sec.title}</p>
                <p className="text-foreground/40 text-xs font-medium">
                  {sec.questions.length} soal &middot; {sec.durationMinutes} menit
                  &middot; PG {sec.passingGrade}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <Button type="button" size="2xl" onClick={onStart} className="mt-5 w-full">
        Mulai Simulasi
      </Button>
    </>
  );
}
